export default __webpack_public_path__ + "media/images/client-logos/twentyci-9a6f268c394323842af3a7e9632fc65d.png";